import {FC, Fragment, useEffect} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'
import {useRouter} from 'next/router'

import SpinnerDots from 'components/elements/SpinnerDots'
import {useAuthStore} from 'src/utils/contexts/RootStore.context'

import s from './PrivateRoute.module.scss'
const cx = cn.bind(s)

interface IPrivateRouteProps {}

const PrivateRoute: FC<IPrivateRouteProps> = ({children}) => {
	const authStore = useAuthStore()
	const router = useRouter()

	useEffect(() => {
		if (!authStore.isLoggedIn) {
			router.replace('/auth/login')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [authStore.isLoggedIn])

	if (!authStore.isLoggedIn)
		return (
			<div className={cx('wrapper')}>
				<SpinnerDots />
			</div>
		)

	return <Fragment>{children}</Fragment>
}

PrivateRoute.displayName = 'PrivateRoute'

export default observer(PrivateRoute)
